const Idencrypt = (value: string, key = '&%key') => {
  let result = '';
  for (let i = 0; i < value.length; i++) {
    let char = value.charAt(i);
    let keychar = key.charAt(i % key.length);
    let ordChar = char.charCodeAt(0);
    let ordKeychar = keychar.charCodeAt(0);
    let sum = ordChar + ordKeychar;
    char = String.fromCharCode(sum);
    result += char;
  }
  // TODO: Use buf.toString('base64') instead of btoa()
  return btoa(result);
};

const Iddecrypt = (input: string, key: string = '%key&'): string => {
  let result = '';

  // Decode the base64-encoded input
  const decodedString = Buffer.from(input, 'base64').toString('utf-8');

  for (let i = 0; i < decodedString.length; i++) {
    const char = decodedString.charAt(i);
    const keyChar = key.charAt(i % key.length);

    // Get the character codes
    const ordChar = char.charCodeAt(0);
    const ordKeyChar = keyChar.charCodeAt(0);

    // Calculate the decrypted character
    const sum = ordChar - ordKeyChar;
    result += String.fromCharCode(sum);
  }

  return result;
}

const encodeBase64Hex = (calId: number | string): string => {
  // Convert calId to string (if it's not already)
  const calIdString = calId.toString();

  // Encode the string to Base64
  const base64Encoded = btoa(calIdString);

  // Convert Base64 string to hexadecimal
  const hexEncoded = Array.from(base64Encoded)
    .map(char => char.charCodeAt(0).toString(16).padStart(2, '0')) // Convert each character to its hex value
    .join('');

  return hexEncoded;
}

const decodeHexBase64 = (hexString: string): string => {
  // Convert hex to binary
  const binaryString = hexString
    .match(/.{1,2}/g) // Split hex string into pairs of two characters
    ?.map(byte => String.fromCharCode(parseInt(byte, 16))) // Convert each pair to a character
    .join('') || '';

  // Decode Base64
  return atob(binaryString);
}

export { Idencrypt, Iddecrypt, decodeHexBase64, encodeBase64Hex };
